import { render, staticRenderFns } from "./AreaPopup.vue?vue&type=template&id=6549b2dd&scoped=true&"
import script from "./AreaPopup.vue?vue&type=script&lang=ts&"
export * from "./AreaPopup.vue?vue&type=script&lang=ts&"
import style0 from "./AreaPopup.vue?vue&type=style&index=0&id=6549b2dd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6549b2dd",
  null
  
)

export default component.exports